import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { Box } from "@vk-hr-tek/ui/Box";
import { Icon } from "@vk-hr-tek/ui/Icon";
import { Tooltip } from "@vk-hr-tek/ui/Tooltip";
import { Typography } from "@vk-hr-tek/ui/Typography";
const DEFAULT_ERROR_TEXT = 'Не удалось загрузить изображения';
const DEFAULT_RETRY_TEXT = 'Попробуйте выполнить поиск еще раз';
const NoImage = (t0)=>{
    const $ = c(13);
    const { isCircle, errorText: t1, retryText: t2 } = t0;
    const errorText = void 0 === t1 ? DEFAULT_ERROR_TEXT : t1;
    const retryText = void 0 === t2 ? DEFAULT_RETRY_TEXT : t2;
    let t3;
    if ($[0] !== errorText) {
        t3 = /*#__PURE__*/ jsx(Typography, {
            variant: "caption",
            color: "bg.light.primary",
            children: errorText
        });
        $[0] = errorText;
        $[1] = t3;
    } else t3 = $[1];
    let t4;
    if ($[2] !== retryText) {
        t4 = /*#__PURE__*/ jsx(Typography, {
            variant: "caption",
            color: "text.dark.secondary",
            children: retryText
        });
        $[2] = retryText;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t3 || $[5] !== t4) {
        t5 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            flexDirection: "column",
            gap: "8",
            children: [
                t3,
                t4
            ]
        });
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else t5 = $[6];
    const t6 = isCircle ? "round" : void 0;
    let t7;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ jsx(Icon, {
            name: "picture_slash_outline",
            size: "20",
            color: "stroke.secondary"
        });
        $[7] = t7;
    } else t7 = $[7];
    let t8;
    if ($[8] !== t6) {
        t8 = /*#__PURE__*/ jsx(Box, {
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            radius: t6,
            bgcolor: "bg.greyscale.primary",
            children: t7
        });
        $[8] = t6;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== t5 || $[11] !== t8) {
        t9 = /*#__PURE__*/ jsx(Tooltip, {
            placement: "top",
            title: t5,
            children: t8
        });
        $[10] = t5;
        $[11] = t8;
        $[12] = t9;
    } else t9 = $[12];
    return t9;
};
export { NoImage };
